import Gooey, {
    Component,
    calc,
    Dyn,
    dynGet,
    dynSet,
    dynSubscribe,
    field,
    model,
    ref,
} from '@srhazi/gooey';
import './bubble-text.css';

export const BubbleText: Component<{
    label: Dyn<string>;
    maxFontWidth?: Dyn<number>;
    minFontWidth?: Dyn<number>;
}> = ({ label, minFontWidth = 0, maxFontWidth = 100 }, { onMount }) => {
    const elementDimensions = new Map<
        HTMLSpanElement,
        { top: number; left: number; width: number; height: number }
    >();
    const spanPosition = model({
        left: 0,
        top: 0,
    });
    const spanRef = ref<HTMLSpanElement>();
    const onMouseMove = (e: MouseEvent) => {
        if (spanRef.current) {
            Array.from(spanRef.current?.childNodes).forEach((charEl) => {
                if (
                    charEl instanceof HTMLSpanElement &&
                    charEl.className === 'bubble-text_char'
                ) {
                    const bounds = elementDimensions.get(charEl);
                    if (bounds) {
                        const cx =
                            spanPosition.left + bounds.left + bounds.width / 2;
                        const cy =
                            spanPosition.top + bounds.top + bounds.height / 2;
                        const dx = cx - e.clientX;
                        const dy = cy - e.clientY;
                        const distance = Math.sqrt(dx ** 2 + dy ** 2);
                        const scaledDistance =
                            Math.max(100 - distance ** 2 / 100, 0) / 100;
                        charEl.style.setProperty(
                            '--bubble-text_char_distance',
                            scaledDistance.toString()
                        );
                    } else {
                    }
                }
            });
        }
    };
    onMount(() => {
        document.body.addEventListener('mousemove', onMouseMove);
        const handle = setInterval(() => {
            if (spanRef.current) {
                const bounds = spanRef.current.getBoundingClientRect();
                spanPosition.top = bounds.top;
                spanPosition.left = bounds.left;
            }
        }, 100);
        return () => {
            document.body.removeEventListener('mousemove', onMouseMove);
            clearInterval(handle);
        };
    });
    return (
        <>
            {calc(() => {
                return (
                    <span
                        ref={(el) => {
                            spanRef.current = el;
                            if (el) {
                                const bounds = el.getBoundingClientRect();
                                spanPosition.top = bounds.top;
                                spanPosition.left = bounds.left;
                                el.childNodes.forEach((charEl) => {
                                    if (charEl instanceof HTMLSpanElement) {
                                        const bounds =
                                            charEl.getBoundingClientRect();
                                        const left =
                                            bounds.left - spanPosition.left;
                                        const top =
                                            bounds.top - spanPosition.top;
                                        elementDimensions.set(charEl, {
                                            left,
                                            top,
                                            width: bounds.width,
                                            height: bounds.height,
                                        });
                                    }
                                });
                            } else {
                                elementDimensions.clear();
                            }
                        }}
                        style={calc(() =>
                            [
                                `--bubble-text_min-font-width: ${dynGet(
                                    minFontWidth
                                )}`,
                                `--bubble-text_max-font-width: ${dynGet(
                                    maxFontWidth
                                )}}`,
                            ].join(';')
                        )}
                        class="bubble-text"
                    >
                        {dynGet(label)
                            .split('')
                            .map((c) => (
                                <span class="bubble-text_char">{c}</span>
                            ))}
                    </span>
                );
            })}
        </>
    );
};
